var _mask, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2404_2752",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.9319L21.75 10.6819L10.5 21.9319Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.9319L21.75 10.6819L10.5 21.9319Z",
    fill: "#76808D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2071 22.639L22.4571 11.389L21.0429 9.97478L9.79289 21.2248L11.2071 22.639ZM21.0429 9.97478L9.79289 21.2248L11.2071 22.639L22.4571 11.389L21.0429 9.97478Z",
    fill: "#76808D",
    mask: "url(#path-1-inside-1_2404_2752)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2404_2752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40253 15.3075L13.4502 22.632L22.8475 10.6141",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2404_2752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 13.5,
    fill: "white",
    transform: "translate(7.75 9.93188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a81fc9c801c205ed35238edbdc771f8b.svg";
export { ForwardRef as ReactComponent };